module.exports = "/images/milano-4.jpg";